export const PRIVACY = './html/privacy.html'
export const AGREEMENT = './html/agreement.html'
export const VERSION = '1.0.0'
export const DEV_CODE = 'web'
export const DEV_NAME = 'web'
export const ENDPOINT_TYPE = 2
export const OS_CODE = 1004004
export const OS_VER = ''